/**
 * 点击触发，滚动到具体的 dom 视图
 */

const NAVI_BAR_HEIGHT = 0

const SCROLL_TO = top => {
  window.scrollTo({
    top: top,
    left: 0,
    behavior: 'smooth'
  })
}

const triggerscrollto = {
  bind (el, binding) {
    const { value } = binding
    if (!value) return

    const clickListener = () => {
      if (value.toTop) SCROLL_TO(0)
      const scrollToViewDom = document.getElementById(value)
      if (!scrollToViewDom) return

      const safeDistance = scrollToViewDom.offsetTop - NAVI_BAR_HEIGHT
      SCROLL_TO(safeDistance)
    }

    el.__clickListener__ = clickListener
    el.addEventListener('click', clickListener, false)
  },

  unbind (el) {
    el.removeEventListener('click', el.__clickListener__)
    delete el.__clickListener__
  }
}

export default triggerscrollto
